import { useQuery } from '@tanstack/react-query';

import { getMyCompanies } from '../../../http/Company/CompanyUserApi';
import queryKeys from './queryKeys';

const useUserCompanies = () =>
  useQuery({
    queryKey: [queryKeys.userCompanies],
    queryFn: getMyCompanies,
    staleTime: 30_000
  });

export default useUserCompanies;
